<template>
  <div class="welfare-container">
    <div v-if="!activeComponent" class="grid-container">
      <a-row :gutter="[16, 16]">
        <a-col :xs="24" :sm="12" :md="8" v-for="(card, index) in cards" :key="index">
          <a-card hoverable class="welfare-card" @click="selectComponent(card)">
            <div class="card-content text-center">
              <img :src="card.icon" class="card-icon" />
              <h4 class="card-title">{{ card.title }}</h4>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
    
    <div v-else class="detail-container">
      <div style="display: flex; align-items: center; margin-bottom: 24px; cursor: pointer;" @click="activeComponent = null">
        <a-icon type="arrow-left" style="font-size: 22px; margin-right: 12px; color: #1a1a2e;" />
        <h5 style="margin-bottom: 0; font-weight: 700; color: #1a1a2e; font-size: 20px;">{{ listData[activeIndex].title }}</h5>
      </div>
      <component :is="activeComponent" :item="listData[activeIndex]"></component>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import WelfareAllowance from './welfare/WelfareAllowance.vue';
import GroupInsurance from './welfare/GroupInsurance.vue';
import ChildrenScholarship from './welfare/ChildrenScholarship.vue';
import ProvidentFund from './welfare/ProvidentFund.vue';
import WelfareAnnouncement from './welfare/WelfareAnnouncement.vue';

export default {
  components: {
    WelfareAllowance,
    GroupInsurance,
    ChildrenScholarship,
    ProvidentFund,
    WelfareAnnouncement
  },
  data() {
    return {
      activeComponent: null,
      activeIndex: 0,
      loading: false,
      docs: [],
      cards: [
        { title: 'Welfare Allowance', icon: '/images/hri_dashboard/walfare/WelfareAllowance.png', component: 'WelfareAllowance', index: 0 },
        { title: 'Group Insurance', icon: '/images/hri_dashboard/walfare/GroupInsurance.png', component: 'GroupInsurance', index: 1 },
        { title: 'Children’s Scholarship', icon: '/images/hri_dashboard/walfare/ChildrenScholarship.png', component: 'ChildrenScholarship', index: 2 },
        { title: 'Provident Fund', icon: '/images/hri_dashboard/walfare/WelfareAnnounement.png', component: 'ProvidentFund', index: 3 },
        { title: 'Welfare Announcement', icon: '/images/hri_dashboard/walfare/WelfareAnnounement.png', component: 'WelfareAnnouncement', index: 4 },
      ],
      listData: [
        {
          title: 'สวัสดิการสงเคราะห์ / Welfare Allowance',
          description: 'ภาพรวมและขั้นตอนการขอรับสวัสดิการเงินช่วยเหลือ ประกอบด้วย ค่าเยี่ยมคลอด ค่าเยี่ยมไข้ โรคร้ายแรง และค่าฌาปนกิจสงเคราะห์',
          content: 'An Overview and Steps for Welfare Allowance: Childbirth, Hospital Visit, Critical Illness and Funeral',
          docs: [
            { thName: 'แบบฟอร์มขอรับสวัสดิการ', enName: 'Welfare Allowance Form', thLink: '#', enLink: '#', updatedAt: new Date() }
          ]
        },
        {
          title: 'ประกันกลุ่ม / Group Insurance',
          description: 'ข้อมูลเกี่ยวกับสิทธิประโยชน์ประกันกลุ่ม คู่มือการสมัคร Application ของ บมจ.ไทยประกันชีวิต (Group Life Beside You) แบบฟอร์มผู้รับผลประโยชน์ การเบิกค่ากายภาพบำบัด',
          content: '- Group Insurance Benefits Information\n- User Guide for the Group Life Beside You Application (Thai Life Insurance)\n- Beneficiary Designation Form\n- Claiming Physical Therapy',
          docs: [
            { thName: 'แบบฟอร์มและคู่มือประกันกลุ่ม', enName: 'Group Insurance Manual & Forms', thLink: '#', enLink: '#', updatedAt: new Date() }
          ]
        },
        {
          title: 'Children’s Scholarship',
          description: '',
          content: '<span style="background-color: yellow;"><b>1. ทุนการศึกษาสำหรับบุตรพนักงานวิทยาลัยนานาชาติ (ประเภทวิชาการและสนับสนุน)</b></span><br>หลักเกณฑ์การขอรับทุนการศึกษาสำหรับบุตรพนักงานวิทยาลัยนานาชาติ เพื่อเข้ารับการศึกษา ณ ศูนย์เตรียมความพร้อมภาษาและคณิตศาสตร์และวิทยาลัยนานาชาติ มหาวิทยาลัยมหิดล <br><br>Children\'s Scholarship for the College Staff (Academic and Support Staff)<br> <b> Eligibility Criteria for the College Staff Children\'s Scholarship for Studies at the Preparation Center for Languages and Mathematics and the Undergraduate Programs at Mahidol University International College</b><br><br><span style="background-color: yellow;"><b>2. ทุนการศึกษาสำหรับบุตรพนักงานวิทยาลัยนานาชาติ (ประเภทสนับสนุน)</b></span><br>หลักเกณฑ์และอัตราการให้ทุนการศึกษาสำหรับบุตรพนักงานวิทยาลัย (ประเภทสนับสนุน) ขั้นตอนการขอรับทุนการศึกษา และแบบฟอร์มการขอรับทุนการศึกษา',
          docs: [
            { thName: 'แบบฟอร์มขอรับทุนการศึกษา', enName: 'Scholarship Application Form', thLink: '#', enLink: '#', updatedAt: new Date() }
          ]
        },
        {
          title: 'Provident Fund',
          description: 'กองทุนสำรองเลี้ยงชีพ (Provident Fund)',
          content: 'ข้อมูลและรายละเอียดเกี่ยวกับกองทุนสำรองเลี้ยงชีพ',
          link: 'https://drive.google.com/file/d/1Yi-gNL7olpQx1SnAbU6CGj04s00YaYSy/view',
          docs: []
        },
        {
          title: 'Welfare Announcement',
          description: 'ประกาศและข่าวสารเกี่ยวกับสวัสดิการต่างๆ',
          content: '',
          docs: []
        }
      ]
    };
  },
  mounted() {
    this.fetchDocs();
  },
  methods: {
    selectComponent(card) {
      this.activeComponent = card.component;
      this.activeIndex = card.index;
    },
    async fetchDocs() {
      this.loading = true;
      try {
        const res = await this.$http.get('/hri/doc-file/?doc_type=form');
        if (res.status === 200 && Array.isArray(res.data)) {
          this.docs = res.data;
          
          const wfDocs = this.docs.filter(d => d.file_name && d.file_name.includes('_WF_'));
          wfDocs.sort((a, b) => {
            const isThA = a.file_name.includes('_WF_th_');
            const isThB = b.file_name.includes('_WF_th_');
            
            if (isThA && !isThB) return -1;
            if (!isThA && isThB) return 1;

            const getNum = (name) => {
              const match = name.match(/_WF_(?:th_)?(\d+)/);
              return match ? parseInt(match[1], 10) : 0;
            };

            const numA = getNum(a.file_name);
            const numB = getNum(b.file_name);
            
            if (numA !== numB) return numA - numB;
            return a.file_name.localeCompare(b.file_name);
          });

          this.listData[0].docs = wfDocs.map(doc => ({
            thName: doc.file_name.replace(/_WF.*$/, ''),
            originalName: doc.file_name,
            thLink: doc.doc_file,
            updatedAt: doc.updated_at || doc.created_at
          }));

          const giDocs = this.docs.filter(d => d.file_name && d.file_name.includes('_GI_'));
          giDocs.sort((a, b) => {
            const isThA = a.file_name.includes('_GI_th_');
            const isThB = b.file_name.includes('_GI_th_');
            
            if (isThA && !isThB) return -1;
            if (!isThA && isThB) return 1;

            const getNum = (name) => {
              const match = name.match(/_GI_(?:th_)?(\d+)/);
              return match ? parseInt(match[1], 10) : 0;
            };

            const numA = getNum(a.file_name);
            const numB = getNum(b.file_name);
            
            if (numA !== numB) return numA - numB;
            return a.file_name.localeCompare(b.file_name);
          });

          this.listData[1].docs = giDocs.map(doc => ({
            thName: doc.file_name.replace(/_GI.*$/, ''),
            thLink: doc.doc_file,
            updatedAt: doc.updated_at || doc.created_at
          }));

          const csDocs = this.docs.filter(d => d.file_name && (d.file_name.includes('_CS_') || d.file_name.includes('HR2026')));
          csDocs.sort((a, b) => {
            const isThA = a.file_name.includes('_CS_th_');
            const isThB = b.file_name.includes('_CS_th_');
            
            if (isThA && !isThB) return -1;
            if (!isThA && isThB) return 1;

            const getNum = (name) => {
              const match = name.match(/_CS_(?:th_)?(\d+)/);
              return match ? parseInt(match[1], 10) : 0;
            };

            const numA = getNum(a.file_name);
            const numB = getNum(b.file_name);
            
            if (numA !== numB) return numA - numB;
            return a.file_name.localeCompare(b.file_name);
          });

          this.listData[2].docs = csDocs.map(doc => ({
            thName: doc.file_name.replace(/_CS.*$/, ''),
            file_name: doc.file_name,
            doc_file: doc.doc_file,
            thLink: doc.doc_file,
            updatedAt: doc.updated_at || doc.created_at
          }));
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching docs:", error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.welfare-container {
  padding: 0 20px;
}
.welfare-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}
.welfare-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}
.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
}
.card-icon {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 20px;
}
.card-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}
.pl-0 {
  padding-left: 0;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-15 {
  margin-bottom: 15px;
}
.pb-50 {
  padding-bottom: 50px;
}
</style>
